// Palette tokens + presets + per-section style CSS (homepage blocks wrapped in [data-home-section]).
export const PALETTE_KEYS = ['gold', 'navy', 'bg', 'bg_alt', 'text'];
export const PALETTE_DEFAULTS = { gold: '#c5a059', navy: '#0b101e', bg: '#ffffff', bg_alt: '#ebe7dd', text: '#0b101e' };
export const PALETTE_VARS = { gold: '--site-gold', navy: '--site-navy', bg: '--site-bg', bg_alt: '--site-bg-alt', text: '--site-text' };
export const PALETTE_META = {
  gold: { title: 'Dourado', hint: 'Destaques, ícones, detalhes e botões dourados' },
  navy: { title: 'Azul-marinho', hint: 'Cor principal: rodapé, faixas escuras, botões' },
  bg: { title: 'Fundo claro', hint: 'Fundo padrão das páginas (também usado como texto claro sobre áreas escuras)' },
  bg_alt: { title: 'Fundo alternativo', hint: 'Degradê do Contato e áreas creme' },
  text: { title: 'Texto principal', hint: 'Cor base dos textos do site' },
};
export const PALETTE_PRESETS = [
  { id: 'belmond', name: 'Belmond (atual)', colors: { gold: '', navy: '', bg: '', bg_alt: '', text: '' } },
  { id: 'vaticano', name: 'Vaticano Branco & Ouro', colors: { gold: '#c9a227', navy: '#3a2e1f', bg: '#fffdf7', bg_alt: '#f3ead3', text: '#2a2218' } },
  { id: 'mariano', name: 'Azul Mariano', colors: { gold: '#c8a96a', navy: '#1d3a6e', bg: '#f8fafd', bg_alt: '#e3ebf6', text: '#14264a' } },
  { id: 'terra', name: 'Terra Santa', colors: { gold: '#b5763c', navy: '#3d2b1f', bg: '#fbf7f0', bg_alt: '#efe3d0', text: '#3a2a1c' } },
  { id: 'bordo', name: 'Bordô Litúrgico', colors: { gold: '#c9a45c', navy: '#5a1626', bg: '#fffaf7', bg_alt: '#f1e4df', text: '#2e0f17' } },
];

export const resolveColor = (value, palette = {}) =>
  (PALETTE_KEYS.includes(value) ? (palette[value] || PALETTE_DEFAULTS[value]) : value);
export const isDark = (hex) => {
  const n = parseInt((hex || '#ffffff').slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return 0.2126 * r + 0.7152 * g + 0.0722 * b < 140;
};

const PAD = { compact: '3rem', normal: '5rem', spacious: '8rem', extra: '11rem' };
const HERO_H = { compact: '60vh', normal: '75vh', spacious: '90vh', extra: '100vh' };
const JUSTIFY = { left: 'flex-start', center: 'center', right: 'flex-end' };
const ML = { left: '0', center: 'auto', right: 'auto' };
const MR = { left: 'auto', center: 'auto', right: '0' };

const sectionCss = (root, style = {}, palette, hero = false, self = false) => {
  const box = self ? root : `${root} > *`;
  const out = [];
  if (!hero && style.bg) out.push(`${box} { background: ${PALETTE_KEYS.includes(style.bg) ? `var(${PALETTE_VARS[style.bg]})` : style.bg} !important; }`);
  const tone = !hero && (style.text || (style.bg ? (isDark(resolveColor(style.bg, palette)) ? 'light' : 'dark') : ''));
  if (tone) {
    // Only the section itself and its title block change tone; cards keep their own colours.
    const head = self ? root : `${root} [data-section-head]`;
    out.push(`${box}, ${head}, ${head} :is(h1, h2, h3, h4, p, li, label) { color: ${tone === 'light' ? '#ffffff' : 'var(--site-text)'} !important; }`);
    if (tone === 'light') out.push(`${box} :is(.bg-white, [style*="background: rgb(255, 255, 255)"], [style*="background-color: rgb(255, 255, 255)"]) { color: var(--site-text) !important; }`);
  }
  if (style.spacing) out.push(hero ? `${box} { min-height: ${HERO_H[style.spacing]} !important; }` : `${box} { padding-top: ${PAD[style.spacing]} !important; padding-bottom: ${PAD[style.spacing]} !important; }`);
  if (style.align) {
    const head = self ? root : `${root} [data-section-head]`;
    out.push(`${head}, ${head} > * { text-align: ${style.align} !important; margin-left: ${ML[style.align]} !important; margin-right: ${MR[style.align]} !important; }`);
    out.push(`${head} :is(.flex, .inline-flex), ${head}.flex { justify-content: ${JUSTIFY[style.align]} !important; }`);
  }
  return out.join('\n');
};

export const buildSectionCss = (sections = [], palette = {}, pages = {}) => [
  ...sections.map(s => sectionCss(`body.public-mode [data-home-section="${s.key}"]`, s.style, palette, s.key === 'hero')),
  ...['pilgrimages', 'faq', 'lead_group', 'gallery'].flatMap(pg => (pages[pg]?.blocks || []).map(b => sectionCss(`body.public-mode [data-page-block="${pg}-${b.key}"]`, b.style, palette, false, true))),
  sectionCss('body.public-mode [data-page-block="footer"]', pages.footer?.style, palette, false, true),
].filter(Boolean).join('\n');
